export default function IcCoin() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          d="M7.49935 2.91675C4.60077 2.91675 1.66602 3.81858 1.66602 5.54175C1.66602 7.26491 4.60077 8.16675 7.49935 8.16675C10.3985 8.16675 13.3327 7.26491 13.3327 5.54175C13.3327 3.81858 10.3985 2.91675 7.49935 2.91675ZM4.58268 8.71391V10.4639C5.30427 10.6383 6.10227 10.7451 6.91602 10.7795V9.0295C6.12996 8.99888 5.34863 8.8932 4.58268 8.71391ZM8.08268 9.02891V10.7789C8.86879 10.7489 9.65018 10.6432 10.416 10.4633V8.71333C9.65018 8.89323 8.86879 8.99891 8.08268 9.02891ZM11.5827 8.34V10.09C12.6333 9.64958 13.3327 9.00675 13.3327 8.16675V6.41675C13.3327 7.25675 12.6333 7.89958 11.5827 8.34ZM3.41602 10.09V8.34C2.36602 7.89958 1.66602 7.25616 1.66602 6.41675V8.16675C1.66602 9.00616 2.36602 9.64958 3.41602 10.09Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
